import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  Typography
} from "@mui/material";
// import "./test.css";

import manImage from "../assets/male.png"
import femaleImage from "../assets/female.png"

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getAllEmployeeList } from "../features/employeeInfo/appoinmentDashboardApi";
// import { getAlldetailSerice } from "../services/servicesListApi";
// import { getAllEmployeeList } from "../features/employeeInfo/appoinmentDashboardApi";

dayjs.extend(utc);
dayjs.extend(timezone);

const EmployeeModal = ({ open, setOpen, callback }) => {
  const appnType = useSelector((state) => state.reducer.apppoinmentUerType);
  const dispatch = useDispatch();
  const info = useSelector((state) => state.reducer.detail);
  const struct = {
    billerId: "",
    customerName: "",
    mobileNumber: "",
    // otp: "",
    mailId: "",
    gender: "",
    service: "",
    date: "",
    hour: "",
    minute: "",
    status: "Unassigned",
  }
  const [formData, setFormData] = useState({ ...struct });

  useEffect(() => {
    console.log("formate date  ", timeValue);
    console.log("ppoinment22 ", info);
  }, [formData]);
  const [dateValue, setDateValue] = useState(dayjs());
  const [timeValue, setTimeValue] = useState(dayjs());
  const [otpEnabled, setOtpEnabled] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log()
    if (typeof value == "object") {
      setFormData({
        ...formData,
        [name]: value[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const setDate = (newValue) => {
    setDateValue(newValue);

    // const date = dayjs(newValue).tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSZ');

    // console.log("date ",date)

    const date = dayjs(newValue).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

    console.log("date", date);

    // console.log("data ",date)
    setFormData((prev) => {
      return { ...prev, date: date };
      // return {...prev,date:date}
    });
  };

  const setTime = (newValue) => {
    setFormData((prev) => {
      if (newValue["$H"] == 20) {
        prev.hour = newValue["$H"] + 12;
      } else {
        prev.hour = newValue["$H"];
      }
      prev.minute = newValue["$m"];
      return { ...prev };
    });
    setTimeValue(newValue);
  };

  const handleTagsChange = (e) => {
    const { value } = e.target;

    console.log("val8e ", value);
    setFormData({
      ...formData,
      service: value,
    });
  };

  const gender = (e) => {
    setFormData((prev) => {
      let temp = { ...prev };
      if (e.target) {
        temp.gender = e.target.value;
      } else {
        temp.gender = e;
      }
      return { ...temp };
    });
  };

  const handleVerifymobileNumber = () => {
    if (formData.mobileNumber) {
      setOtpEnabled(true);
    }
  };

  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(appnType, "appnType");

    const formDataobj = new FormData();
    Object.keys(formData).forEach((key, index) => {
      formDataobj.append(key, formData[key]);
    });
    const condition = appnType == "profile";
    console.log("value ", { ...formData, date: formData.date })
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [servicesArr, setservicesArr] = useState([
    {
      serviceName: "Shaving",
      rate: "100.00/Per Head",
    },
    {
      serviceName: "Hair cutting",
      rate: "150.00/Per Head",
    },
  ]);
  const names = [
    "Haircut",
    "Hair Coloring",
    "Hair Styling",
    "Manicure",
    "Pedicure",
    "Facial",
    "Waxing",
    "Massage",
    "Makeup",
    "Bridal Makeup",
    "Threading",
    "Hair Spa",
    "Nail Art",
    "Skin Treatment",
  ];
  useEffect(() => {
    setFormData({
      ...formData,
      billerId: info.billerId,
    });
    setDate(timeValue);
    setTime(timeValue);
    gender("male");
  }, []);

  const infoD = useSelector((state) => state.reducer.detail);

  const [tables, setTables] = useState([])
  useEffect(() => {
    if (open == true) {
      getAllEmployeeList((res) => {
        console.log("getAllEmployeeList", res);
        setTables(res?.list);
      });

    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={() => {
        setFormData({ ...struct });
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",

          width: { xs: "95%", sm: "85%", md: "52%", lg: "52%", xl: "52%" },

          overflowY: "auto",
          zIndex: "99999",
          borderRadius: "10px",
          // height: "90vh",
          position: "absolute",
                    left: { xs: "2%", sm: "5%", md: "25%", lg: "25%", xl: "25%" }
,
                   top: { xs: "5%", sm: "2%", md: "6%" },

        }}
      >
        <Container sx={{ padding: "20px" }}>
          <Grid
            container
            sx={{
              overflowY: "auto",
              maxHeight: {
                xs: "calc(100vh - 60px)",
                sm: "calc(80vh - 60px)",
              },
              paddingRight: "15px",
            }}
          >
            {tables.map((item2, index) => {
              return (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  key={"tableListBill" + index}
                  sx={{
                    padding: "8px 20px",
                  }}
                >
                  <Box
                    onClick={() => {
                      //   dispatch(setTableName(item2.name));
                      //   navigate(routePath.COUNTERSELLBILLING);
                      callback(item2);
                    }}
                    sx={{
                      margin: "0px 10px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "start",
                      backgroundColor: "#EEEEFF",
                      alignItems: "center",
                      width: "100%",
                      fontWeight: "bold",
                      height: "70px",
                      borderRadius: "6px",
                    }}
                  >
                    <Box
                      component="img"
                      src={
                        item2.gender === "female" || item2.gender === "Female"
                          ? femaleImage
                          : manImage
                      }
                      sx={{
                        width: "39px",
                        borderRadius: "50%",
                        marginX: "20px",
                      }}
                    />
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontFamily: "'Montserrat', sans-serif",
                        }}
                      >
                        Emp ID: {}
                        <Typography
                          component="span"
                          color="primary"
                          sx={{
                            fontSize: "14px",
                            fontWeight: 500,
                            fontFamily: "'Montserrat', sans-serif",
                          }}
                        >
                          {item2.employeeId ?? "NA"}
                        </Typography>
                      </Typography>
                      <Typography
                        color="primary"
                        sx={{
                          fontSize: "16px",
                          fontWeight: 600,
                          fontFamily: "'Montserrat', sans-serif",
                        }}
                      >
                        {item2.name}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Container>{" "}
      </Box>
    </Modal>
  );
};

export default EmployeeModal;
